import Button from "../../../../shared/button";
import Table from "../../../../shared/table";
import { useGetCurrentAuthUrlQuery } from "../../../../store/reservations/reservationsApi";

const tableColumns = ["Sent from", "Email Sent at"];

const InvoiceEmailsTable = () => {
  const { data: authUrl } = useGetCurrentAuthUrlQuery({});

  const onClickButton = () => {
    window.location.assign(authUrl);
  };

  return (
    <div className="bg-white p-4">
      <h2 className="text-[#5D6679] text-base mb-2">Invoice E-mails</h2>
      <div className="bg-[#F9F9F9] rounded-lg px-4 py-6">
        <div className="flex flex-row items-center">
          <img src="/assets/shared/email.svg" alt="Email Icon" />
          <div className="ml-3">
            <p className="text-[#161048] text-xs">Last Processing - </p>
            <h4 className="text-[#202020] text-base font-bold">New Emails</h4>
          </div>
        </div>
        <Button
          icon={
            <img
              alt="reviewt"
              className="mr-2"
              src="/assets/shared/reviewt.svg"
            />
          }
          onClickButton={onClickButton}
          label="Review Reservation Emails"
          className="mt-3 bg-primary-default rounded-xl py-2 px-4 text-white flex flex-row items-center"
        />
      </div>
      <Table columns={tableColumns} hidePagination></Table>
    </div>
  );
};

export default InvoiceEmailsTable;
